import React, { useState, useEffect, useCallback } from "react";
import FullscreenIcon from "@mui/icons-material/Fullscreen";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import BrianyCareFullLogo from "../assets/auth/logo.png";
import CallIcon from '@mui/icons-material/Call';
import api from "../api/api";
import "./Bell.css";
import { useParams } from "react-router-dom";
import { providerColorCodes } from "./providerColorCodes";

const MedTrack = () => {
  const [currentTime, setCurrentTime] = useState(new Date());
  const [rooms, setRooms] = useState([]);
  const [waitingRoomCount, setWaitingRoomCount] = useState(0);
  const [loading, setLoading] = useState(true);
  // const [appointments, setAppointments] = useState([]);
  const [waitingPatients, setWaitingPatients] = useState([]);
  const practiseid = window.getPracticeId();

  const [teleHealthPatients, setTeleHealthPatients] = useState([]);
  const [teleConfirmedCount, setTeleConfirmedCount] = useState(0);
   
  const currentYear = new Date().getFullYear();
  const {ak} = useParams();

  // Fetch rooms from API
  //orignial
  let newak='127d196f773179685bb945abb7a8f781'

const decode = (value) => {
  const base64 = value
    .replace(/-/g, '+')
    .replace(/_/g, '/');

  return atob(base64);
};
const realAK = decode(ak);
let isValid= (realAK===newak)

 // Fetch display data (appointments) every 3 seconds
  const fetchDisplayData = useCallback(async () => {
    try {
      const today = new Date().toISOString().split("T")[0]; // Get today's date in YYYY-MM-DD format
      // console.log("Fetching display data for date:", today);
      const data = await api.get(`/v1/${practiseid}/medtrack/get`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            practiceid: practiseid,
            appointmentdate: today,
            searchflag: null,
            page: "1",
            limit: "6",
          }),
        }
      );

      // const data = await response.json();
      console.log("Fetched display data:", data);
      if (data.status === 200) {
        // Store all appointments
        // if (data.allappts) {
        //   setAppointments(data.allappts);
        // }
        // console.log("Ready for ALLData Data:", data.data);
        // console.log("Ready for Triage Data:", data.readyforTriage);
        // Get waiting patients (Ready for Triage)
        if (data.data) {
           const readyForTriage =  data.readyforTriage || [];
            // Update waiting room count
            // if (data.inofficeCount !== undefined) {
            setWaitingRoomCount(readyForTriage.length);
            // }
          // Extract readyforTriage array from each item
          const waitingList = [];
          readyForTriage.forEach((item) => {
            if (item.readyforTriage && Array.isArray(item.readyforTriage)) {
              waitingList.push(...item.readyforTriage);
            }
          });
          setWaitingPatients(readyForTriage);
        }

        if (data.teleconfirmed) {
           const teleConfirmed =  data.teleconfirmed || [];
            setTeleConfirmedCount(teleConfirmed.length);
          // Extract teleConfirmed array from each item
          const teleHealthList = [];
          teleConfirmed.forEach((item) => {
            if (item.teleConfirmed && Array.isArray(item.teleConfirmed)) {
              teleHealthList.push(...item.teleConfirmed);
            }
          });
          setTeleHealthPatients(teleConfirmed);
        }


        // Update rooms with appointment data using functional update
        setRooms((prevRooms) => {
          if (data.data && prevRooms.length > 0) {
            return prevRooms.map((room) => {
              // Find appointment for this room - check if room_no is not null and not empty0
              const appointment = data.data.find(
                (apt) => apt.room_no !== null && apt.room_no !== "" && apt.room_no.trim() === room.name
              );

              if (appointment) {
                return {
                  ...room,
                  assignedUser: `${appointment.firstname} ${appointment.lastname}`,
                  appointmentData: {
                    start_time: appointment.start_time,
                    id: appointment.id,
                    patientid: appointment.patientid,
                    firstname: appointment.firstname,
                    lastname: appointment.lastname,
                    token: appointment.token,
                    linked_provider: appointment.linked_provider,
                    room_no: appointment.room_no,
                    roomAssignInterval: appointment.roomAssignInterval || 0,
                    recordingBy: appointment.recordingBy,
                    startRecording: appointment.startRecording,
                    stopRecording: appointment.stopRecording,
                  },
                };
              } else {
                return {
                  ...room,
                  assignedUser: null,
                  appointmentData: null,
                };
              }
            });
          }
          return prevRooms;
        });
      }
    } catch (error) {
      console.error("Error fetching display data:", error);
    }
  }, [practiseid]);


const fetchRooms = useCallback(async () => {
  setLoading(false);
  try {
    const res = await api.get(`/v1/${practiseid}/medtrack/get_rooms`);
    if (res.status === 200) {
      const transformedRooms = res.data.map((room) => ({
        id: room.id,
        name: room.room,
        assignedUser: null,
        token: null,
        providerName: null,
      }));
      // console.log("Transformed Rooms:", transformedRooms);
      setRooms(transformedRooms);
      setLoading(true);
      fetchDisplayData();
    }
  } catch (e) {
    console.error("Error fetching rooms:", e);
    setLoading(false);
  }
}, [practiseid, fetchDisplayData]);

// Fetch rooms on component mount
useEffect(() => {
  fetchRooms();
}, [fetchRooms]);


  // Fetch display data every 3 seconds

// useEffect(() => {
//   if (loading && rooms.length > 0) {
//     fetchDisplayData();
//     const interval = setInterval(() => {
//       fetchDisplayData();
//     }, 3000);

//     return () => clearInterval(interval);
//   }
// }, [loading, rooms, fetchDisplayData]); 

useEffect(() => {
  let cancelled = false;
  const fetchAndSchedule = async () => {
    if (cancelled) return;
    await fetchDisplayData();
    if (!cancelled) setTimeout(fetchAndSchedule, 5000);
  };

  if (loading && rooms.length > 0) {
    fetchAndSchedule();
  }

  return () => {
    cancelled = true;
  };
}, [loading, rooms, fetchDisplayData]);

  // Update time every second
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  // Format time
  const formatTime = (date) => {
    return date.toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true,
    });
  };

  // Handle refresh
  // const handleRefresh = () => {
  //   setCurrentTime(new Date());
  //   // fetchRooms();
  //   if (!loading) {
  //     fetchDisplayData();
  //   }
  // };

  // Handle fullscreen
  const handleFullscreen = () => {
    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen();
    } else {
      document.exitFullscreen();
    }
  };
const providerShortNames = (provider) => {
  if (!provider) return "";

  const name = provider.toLowerCase();

  if (name.toLowerCase().includes("madhu")) return "Dr. Madhu";
  if (name.toLowerCase().includes("leanora")) return "Leanora";
  if (name.toLowerCase().includes("jaime")) return "Jaime";
  if (name.toLowerCase().includes("oco")) return "Oco";
  if (name.toLowerCase().includes("reshma")) return "Reshma";
  if (name.toLowerCase().includes("duke")) return "Dr. Duke";

  return provider;
};


if (!isValid) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="bg-white p-8 rounded-xl shadow-lg text-center max-w-md">
        <h2 className="text-2xl font-bold text-red-600 mb-3">
          Access Not Allowed
        </h2>
        <p className="text-gray-600 mb-4">
          Invalid or missing access token.
        </p>
        <p className="text-sm text-gray-400">
          Please contact administrator.
        </p>
      </div>
    </div>
  );
}

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-slate-50 flex flex-col">
      {/* Header */}
      <div className="bg-white backdrop-blur-sm p-1 flex-shrink-0">
        <div className="flex items-center justify-between">
          {/* Logo and Title */}
          <div className="flex items-center gap-4">
            <img src={BrianyCareFullLogo} alt="Brand Logo" className="h-13" />
          </div>

          {/* Time and Actions */}
          <div className="flex items-center gap-4">
            <div className="flex items-center gap-3">
              {/* <AccessTimeIcon
                style={{ fontSize: 20 }}
                className="p-2 text-blue-600"
              /> */}
              <span className="text-4xl font-bold text-gray-900 tracking-wide">
                {formatTime(currentTime)}
              </span>
            </div>

            <button
              onClick={handleFullscreen}
              className="text-white rounded-full transition-all duration-200 p-1" style={{background:'#5c636a'}}
              title="Fullscreen"
            >
              <FullscreenIcon
                style={{ fontSize: 25 }}
                className="text-white "
              />
            </button>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="bg-white flex px-3 pb-8 flex-1 pt-2">
        {/* Room Grid - 60% width */}
        <div className="w-[68%] flex flex-col">
          {!loading ? (
            <div className="flex items-center justify-center h-64">
              <p className="text-gray-600 text-lg">Loading rooms...</p>
            </div>
          ) : (
          Object.entries(
            rooms.reduce((acc, room) => {
               const firstLetter = room.name?.charAt(0).toUpperCase();
                let key;
                if (firstLetter === "A" || firstLetter === "C") {
                  key = "CA";
                } else {
                  key = firstLetter || "Other";
                }
              if (!acc[key]) acc[key] = [];
              acc[key].push(room);
              return acc;
            }, {})
          ).map(([groupName, groupRooms]) => (
            <div key={groupName}
              className="grid gap-2 flex-1 p-1"
              style={{
                gridTemplateColumns: `repeat(auto-fill, minmax(175px, 1fr))`, borderRight: '1px solid #E0E0E0',
              }}
            >
              {groupRooms.map((room) => {
                const isAssigned = room.appointmentData !== null && room.appointmentData !== undefined;
                const isBellAlert = isAssigned && room.appointmentData?.roomAssignInterval > 20 && room.appointmentData?.startAudioRecording === 0;
                const isRecordingBy = room.appointmentData?.recordingBy || "";
                const startRecording = room.appointmentData?.startRecording || "";
                const stopRecording = room.appointmentData?.stopRecording || "";
                // console.log("Recording Status for Room ", room.appointmentData?.patientid, "Recording By :", isRecordingBy, "Start Recording :", startRecording, "Stop Recording :", stopRecording);
                const linked_provider = room.appointmentData?.linked_provider || "";
                const visit_confirmation = room.appointmentData?.visit_confirmation || "";
                let bgclr = ['#F8EEEC', '#000']; // default colors
                if(isRecordingBy === "pr5"){
                    bgclr = providerColorCodes('Leanora', visit_confirmation);
                }else if(isRecordingBy === "reshma"){
                    bgclr = providerColorCodes('Reshma', visit_confirmation);
                }else{
                    bgclr = providerColorCodes(linked_provider, visit_confirmation);
                }


                // console.log("Room Provider :", linked_provider , "Visit Status :", visit_confirmation, "BG Color :", bgclr);
                return (
                  <div
                    key={room.id}
                    className={`
                      group transition-all duration-500 
                      rounded-2xl relative overflow-hidden
                      flex flex-col
                      h-[170px] aspect-square 
                      bg-gradient-to-br shadow-2xl text-black transform-gpu
                    `} style={{
                            background: bgclr[0], color: bgclr[1], marginRight: '3px', width:"100%"
                        }}
                  >
                   

                    {/* Content */}
                    <div className="relative z-10 w-full px-1 py-1">
                      {/* Top section - Time and Token */}
                      {room.appointmentData ? (
                        <div className="flex justify-between items-start">
                          <div className="flex items-center text-md font-bold ml-3">
                            <AccessTimeIcon style={{ fontSize: 16 }} />
                            <span className="text-md font-bold items-center">
                             &nbsp;{room.appointmentData.start_time || ""}
                            </span>
                          </div>
                          <div className="w-10 h-9 rounded-full bg-white backdrop-blur-sm flex items-center justify-center border-2 border-white/50">
                          {startRecording === "Y" && stopRecording === "" ? (
                             <svg
                              fill="#ff5500"
                              width="20px" height="20px"
                              viewBox="0 0 256 256"
                              id="Flat"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path d="M79.99414,127.99609v-64a48,48,0,1,1,96,0v64.00782a48,48,0,0,1-96-.00782Zm120.4375.05469a8.07828,8.07828,0,0,0-8.82812,7.07813,64.00856,64.00856,0,0,1-127.21875-.00782,8.09865,8.09865,0,0,0-8.82813-7.07031,8.01056,8.01056,0,0,0-7.07812,8.83594A79.60051,79.60051,0,0,0,119.99414,207.251v24.74511a8,8,0,1,0,16,0V207.252a79.577,79.577,0,0,0,71.51563-70.373A8.00321,8.00321,0,0,0,200.43164,128.05078Z" />
                            </svg>
                          ) : ( 
                            <span className="text-lg text-black text-center font-black">
                              {room?.appointmentData?.token || ""} 
                            </span>
                          )}                            
                          </div>
                        </div>
                      ) : null}

                      {/* Status indicator */}
                      {room.appointmentData ? (
                        <div className="min-h-[95px]" style={{ marginTop: '-14px' }}>
                          {/* Patient ID */}
                          <div className="flex justify-between items-start">
                            <span className="font-semibold truncate flex items-center">
                                <svg width="16px" height="16px"
                                    style={{ fill: bgclr[1] }}
                                    viewBox="0 0 16 16"
                                    xmlns="http://www.w3.org/2000/svg"
                                    xmlnsXlink="http://www.w3.org/1999/xlink"
                                    className="inline-block"
                                >
                                    <path
                                    d="M12.517 12.834v1.9a1.27 1.27 0 0 1-1.267 1.267h-9.5a1.27 1.27 0 0 1-1.267-1.267v-1.9A3.176 3.176 0 0 1 3.65 9.667h5.7a3.176 3.176 0 0 1 3.167 3.167zM3.264 5.48A3.236 3.236 0 1 1 6.5 8.717a3.236 3.236 0 0 1-3.236-3.236z"
                                    />
                                    <path
                                    d="M12.517 12.834v1.9a1.27 1.27 0 0 1-1.267 1.267h-9.5a1.27 1.27 0 0 1-1.267-1.267v-1.9A3.176 3.176 0 0 1 3.65 9.667h5.7a3.176 3.176 0 0 1 3.167 3.167zM3.264 5.48A3.236 3.236 0 1 1 6.5 8.717a3.236 3.236 0 0 1-3.236-3.236z"
                                    />
                                </svg>&nbsp;
                                <span className="text-lg font-bold">
                                {room.appointmentData.patientid || ""}
                                </span>                            
                            </span>
                          </div>

                            <div className="flex justify-between items-start">
                              {/* Left side: Patient Name and Provider Name in two rows */}
                              <div className="flex flex-col justify-start items-start">
                                {/* Patient Name */}
                                <div className="flex items-center">
                                  <svg
                                    width="16px"
                                    height="16px"
                                    style={{ fill: bgclr[1] }}
                                    viewBox="0 0 16 16"
                                    xmlns="http://www.w3.org/2000/svg"
                                    xmlnsXlink="http://www.w3.org/1999/xlink"
                                    className="inline-block"
                                  >
                                    <path
                                      d="M12.517 12.834v1.9a1.27 1.27 0 0 1-1.267 1.267h-9.5a1.27 1.27 0 0 1-1.267-1.267v-1.9A3.176 3.176 0 0 1 3.65 9.667h5.7a3.176 3.176 0 0 1 3.167 3.167zM3.264 5.48A3.236 3.236 0 1 1 6.5 8.717a3.236 3.236 0 0 1-3.236-3.236z"
                                    />
                                  </svg>&nbsp;
                                  <span className="text-lg font-bold">
                                    {room.appointmentData.lastname?.substring(0, 3) || ""},{" "}
                                    {room.appointmentData.firstname?.charAt(0) || ""}
                                  </span>
                                </div>

                                {/* Provider Name */}
                                <div className="flex items-center">
                                  <svg
                                    width="16px"
                                    height="16px"
                                    viewBox="0 0 16 16"
                                    xmlns="http://www.w3.org/2000/svg"
                                    xmlnsXlink="http://www.w3.org/1999/xlink"
                                  >
                                    <path
                                      style={{ fill: bgclr[1] }}
                                      d="M14 11.3c-1-1.9-2-1.6-3.1-1.7 0.1 0.3 0.1 0.6 0.1 1 1.6 0.4 2 2.3 2 3.4v1h-2v-1h1c0 0 0-2.5-1.5-2.5s-1.5 2.4-1.5 2.5h1v1h-2v-1c0-1.1 0.4-3.1 2-3.4 0-0.6-0.1-1.1-0.2-1.3-0.2-0.1-0.4-0.3-0.4-0.6 0-0.6 0.8-0.4 1.4-1.5 0 0 0.9-2.3 0.6-4.3h-1c0-0.2 0.1-0.3 0.1-0.5s0-0.3-0.1-0.5h0.8c-0.3-1-1.3-1.9-3.2-1.9 0 0 0 0 0 0s0 0 0 0 0 0 0 0c-1.9 0-2.9 0.9-3.3 2h0.8c0 0.2-0.1 0.3-0.1 0.5s0 0.3 0.1 0.5h-1c-0.2 2 0.6 4.3 0.6 4.3 0.6 1 1.4 0.8 1.4 1.5 0 0.5-0.5 0.7-1.1 0.8-0.2 0.2-0.4 0.6-0.4 1.4 0 0.4 0 0.8 0 1.2 0.6 0.2 1 0.8 1 1.4 0 0.7-0.7 1.4-1.5 1.4s-1.5-0.7-1.5-1.5c0-0.7 0.4-1.2 1-1.4 0-0.3 0-0.7 0-1.2s0.1-0.9 0.2-1.3c-0.7 0.1-1.5 0.4-2.2 1.7-0.6 1.1-0.9 4.7-0.9 4.7h13.7c0.1 0-0.2-3.6-0.8-4.7zM6.5 2.5c0-0.8 0.7-1.5 1.5-1.5s1.5 0.7 1.5 1.5-0.7 1.5-1.5 1.5-1.5-0.7-1.5-1.5z"
                                    ></path>
                                    <path
                                      style={{ fill: bgclr[1] }}
                                      d="M5 13.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z"
                                    ></path>
                                  </svg>&nbsp;
                                  <span className="text-lg font-bold">{providerShortNames(room?.appointmentData?.linked_provider || "")}</span>
                                </div>
                              </div>

                              {/* Right side: Bell icon */}
                              <div className="flex items-center justify-center">
                                {isBellAlert ? (
                                  <svg 
                                    className="h-15 w-10 bell-icon BellIcon animate-pulse text-red-900"
                                    viewBox="0 0 16 16"
                                    xmlns="http://www.w3.org/2000/svg"
                                    xmlnsXlink="http://www.w3.org/1999/xlink"
                                  >
                                    <path style={{ fill: bgclr[1] }} d="M13,12.6V7.92A5,5,0,0,0,8.7,3.07V0H7.3V3.07A5,5,0,0,0,3,7.92V12.6H1V14H6a2,2,0,0,0,4,0h5V12.6ZM4.4,7.92a3.6,3.6,0,0,1,7.2,0V12.6H4.4Z"/>
                                  </svg>
                                ) : (
                                  " "
                                )}
                              </div>
                            </div>

                            {/* Medical Assistant */}
                            {isRecordingBy ? (
                            <div className="flex justify-between items-start">
                                <span className="font-semibold truncate flex items-center">
                                  <svg width="16px" height="16px" viewBox="0 0 48 48" fill="none">
                                    <path 
                                      d="M19 20C22.866 20 26 16.866 26 13C26 9.13401 22.866 6 19 6C15.134 6 12 9.13401 12 13C12 16.866 15.134 20 19 20Z" 
                                      style={{ fill: bgclr[1], stroke:bgclr[1] }} 
                                      
                                      strokeWidth="4" 
                                      strokeLinecap="round" 
                                      strokeLinejoin="round" 
                                    />
                                    <path 
                                      d="M33 8C33 8 35.25 12.5 33 18" 
                                      style={{ fill: bgclr[1], stroke:bgclr[1] }}
                                      strokeWidth="4" 
                                      strokeLinecap="round" 
                                      strokeLinejoin="round" 
                                    />
                                    <path 
                                      d="M40 4C40 4 44.5 12.1 40 22" 
                                      style={{ fill: bgclr[1], stroke:bgclr[1] }}
                                      strokeWidth="4" 
                                      strokeLinecap="round" 
                                      strokeLinejoin="round" 
                                    />
                                    <path 
                                      d="M4 40.8V42H34V40.8C34 36.3196 34 34.0794 33.1281 32.3681C32.3611 30.8628 31.1372 29.6389 29.6319 28.8719C27.9206 28 25.6804 28 21.2 28H16.8C12.3196 28 10.0794 28 8.36808 28.8719C6.86278 29.6389 5.63893 30.8628 4.87195 32.3681C4 34.0794 4 36.3196 4 40.8Z"                                       
                                      style={{ fill: bgclr[1], stroke:bgclr[1] }}
                                      strokeWidth="4" 
                                      strokeLinecap="round" 
                                      strokeLinejoin="round" 
                                    />
                                  </svg>                                
                                &nbsp;
                                <span className="text-md font-bold rounded-md text-black" style={{ background: '#FFFF00', padding:"2px" }}>{providerShortNames(isRecordingBy || "")}</span>
                                </span>
                                <span></span>
                            </div>
                            ) : " "}
                            

                        </div>                        
                      ) : (
                        <div className="h-[110px] flex items-center justify-center space-x-4 overflow-hidden" style={{ marginTop: '-15px' }}>
                            <div className="w-24 h-full">&nbsp;</div>
                            <div className="w-24 h-full">&nbsp;</div>
                            <div className="w-24 h-full">&nbsp;</div>
                            <div className="w-24 h-full">&nbsp;</div>
                            <div className="w-24 h-full">&nbsp;</div>
                        </div>
                      )}
                    </div>
                    
                      {/* Waiting time and Room name */}
                    <div className="flex flex-col h-full">
                      {/* Other content here */}
                      <div className="flex justify-between items-start mt-auto w-full pb-2">
                        <span className="py-1 waitingtime text-lg font-bold">
                          {room.appointmentData?.roomAssignInterval > 0 && room.appointmentData?.roomAssignInterval > 20 && room.appointmentData?.startAudioRecording === 0
                            ? `${room.appointmentData?.roomAssignInterval} MINS`
                            : ""}
                        </span>
                        <span className="ml-auto text-right !pr-[15px] font-bold text-lg font-bold">{room.name}</span>
                      </div>
                    </div>
                     

                 </div>
                );
              })}
            </div>
          ))
          )}
        
        </div>

        {/* Waiting Room Sidebar - 40% width */}
        <div className="w-[32%] space-y-4 flex flex-col ml-2">
          {/* Waiting Room Status - Yellow Header */}
          <div className="bg-gradient-to-br rounded-2xl p-1 shadow-lg relative overflow-hidden rounded-xl" style={{ background: '#FFFF00' }}>
            {/* Decorative elements */}
            <div className="absolute top-0 right-0 w-16 h-1 bg-white/20 rounded-full blur-xl transform translate-x-1/2 -translate-y-1/2"></div>
            <div className="absolute bottom-0 left-0 w-12 h-1 bg-white/20 rounded-full blur-lg transform -translate-x-1/2 translate-y-1/2"></div>

            <div className="relative z-10">
              <div className="text-center mb-1">
                <h6 className="uppercase max-w-screen-xl text-center p-1 text-2xl font-bold rounded mb-1">
                  Waiting Room (<span className={ 'text-bold text-pink-500' }>{waitingRoomCount}</span>)
                </h6>
              </div>              
            </div>
          </div>

          {/* Waiting Patients List */}
          <div className="flex-1 relative h-full">
            {/* Subtle pattern */}
            <div className="absolute inset-0 opacity-5">
              <div className="absolute top-0 left-0 w-full h-full bg-[radial-gradient(circle_at_30%_30%,rgba(0,0,0,0.1),transparent_50%)]"></div>
            </div>

            <div className="relative z-10 flex flex-col">
              {waitingPatients.length === 0 ? (
                <div className="flex flex-col items-center h-full">
                  <div className="w-16 h-16 rounded-full bg-pink-100 flex items-center justify-center mb-2">
                    <svg
                      className="w-8 h-8 text-pink-600"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                      />
                    </svg>
                  </div>
                  <p className="text-xl font-bold text-pink-600">
                    No Patients Waiting
                  </p>
                </div>
              ) : (
                <div className="flex flex-col gap-1.5 pr-1 w-full">
                  {waitingPatients.map((patient, index) => (
                    <div
                      key={`${patient.patientid}-${index}`}
                      className="rounded-lg p-1 border-solid border-black shadow-md flex justify-between p-1" style={{ borderWidth: '1px' }}>
                      <div className="w-[45%] flex justify-between p-1">
                        {/* Patient Info - All in one row, wraps to 2 if needed */}
                        <div className="flex justify-between gap-2">
                          {/* Token Circle */}
                            <div className="w-6 h-6 rounded-full bg-orange-500 flex items-center justify-center flex-shrink-0">
                              <span className="text-white font-bold text-md">
                                {index + 1}
                              </span>
                            </div>
                            {/* Left side content */}
                            <div className="flex items-center">
                                <span className="font-semibold text-2xl text-lg">
                                {patient.lastname?.substring(0, 3) || ""}, {patient.firstname?.charAt(0) || ""}
                                </span>
                                <span className="text-orange-500 text-xl text-black">&nbsp; {patient.patientid}</span> 
                                
                            </div>
                        </div>
                      </div>
                        <div className="w-[55%] flex justify-between p-1">
                           <div className={`border-black rounded-2xl p-1 font-medium ${patient.purpose.length > 10 ? 'text-xs' : 'text-md'}`}
                              style={{ borderWidth: '1px' }}
                            >
                              {patient.purpose || ""}
                            </div>

                            {/* Right side content */}
                            <div className="text-right">
                                <span className="text-md font-semibold truncate text-blue-600">
                                {providerShortNames(patient?.linked_provider || "")}
                                </span>
                            </div>
                        </div>                     
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
       





        
          {/* Telehealth - Yellow Header */}
          {teleHealthPatients.length > 0 ? (
          <div className="bg-gradient-to-br rounded-2xl mt-5 p-1 shadow-lg relative overflow-hidden rounded-xl" style={{ background: '#FFFF00' }}>
            {/* Decorative elements */}
            <div className="absolute top-0 right-0 w-16 h-1 bg-white/20 rounded-full blur-xl transform translate-x-1/2 -translate-y-1/2"></div>
            <div className="absolute bottom-0 left-0 w-12 h-1 bg-white/20 rounded-full blur-lg transform -translate-x-1/2 translate-y-1/2"></div>

            <div className="relative z-10">
              <div className="text-center mb-1">
                <h6 className="uppercase max-w-screen-xl text-center p-1 text-2xl font-bold rounded mb-1">
                  Tele-Health (<span className={ 'text-bold text-pink-500' }>{teleConfirmedCount}</span>)
                </h6>
              </div>              
            </div>
          </div>
          ) : null}

          {/* Telehealth Patients List */}
          {teleHealthPatients.length > 0 ? (
          <div className="flex-1 relative h-full">
            {/* Subtle pattern */}
            <div className="absolute inset-0 opacity-5">
              <div className="absolute top-0 left-0 w-full h-full bg-[radial-gradient(circle_at_30%_30%,rgba(0,0,0,0.1),transparent_50%)]"></div>
            </div>

            <div className="relative z-10 flex flex-col h-full">
              {teleHealthPatients.length === 0 ? (
                <div className="flex flex-col items-center h-full">
                  <div className="w-16 h-16 rounded-full bg-pink-100 flex items-center justify-center mb-2">
                    <svg
                      className="w-8 h-8 text-pink-600"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                      />
                    </svg>
                  </div>
                  <p className="text-xl font-bold text-pink-600">
                    No Patients Waiting
                  </p>
                </div>
              ) : (
                <div className="flex flex-col gap-1.5 pr-1 w-full">
                  {teleHealthPatients.map((patient, index) => (
                    <div
                      key={`${patient.patientid}-${index}`}
                      className="rounded-lg p-1 border-solid border-black shadow-md flex justify-between p-1" style={{ borderWidth: '1px' }}>
                      <div className="w-[45%] flex justify-between p-1">
                        {/* Patient Info - All in one row, wraps to 2 if needed */}
                        <div className="flex justify-between gap-2">
                          {/* Token Circle */}
                            <div className="w-6 h-6 rounded-full bg-orange-500 flex items-center justify-center flex-shrink-0">
                              <span className="text-white font-bold text-md">
                                <CallIcon/>
                              </span>
                            </div>
                            {/* Left side content */}
                            <div className="flex items-center">
                                <span className="font-semibold text-2xl text-lg">
                                {patient.lastname?.substring(0, 3) || ""}, {patient.firstname?.charAt(0) || ""}
                                </span>
                                <span className="text-orange-500 text-xl text-black">&nbsp; {patient.patientid}</span> 
                                
                            </div>
                        </div>
                      </div>
                        <div className="w-[55%] flex justify-between p-1">
                           <div className={`border-black rounded-2xl p-1 font-medium ${patient.purpose.length > 10 ? 'text-xs' : 'text-md'}`}
                              style={{ borderWidth: '1px' }}
                            >
                              {patient.purpose || ""}
                            </div>

                            {/* Right side content */}
                            <div className="text-right">
                                <span className="text-md font-semibold truncate text-blue-600">
                                {providerShortNames(patient?.linked_provider || "")}
                                </span>
                            </div>
                        </div>                     
                    </div>
                  ))}
                </div>
              )}
            </div>            
          </div>
          ) : null}
        </div>


      </div>
      <footer className="site-footer text-center my-3 fixed bottom-0 w-full py-2 text-blue-600 text-lg">
      <strong>
        Powered by{' '}
        <img
          src="https://brainymed.com/bmv3/images/favicon.ico"
          alt="BrainyMed Logo"
          height="42"
          className="inline-block mr-2"
        />
        BrainyMed
      </strong>
    </footer>
    </div>
    // </div>
  );
};

export default MedTrack;
